import React from 'react'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'

import { SECTION_STATES, hasConfirmedSectionData } from './sectionState'

const retryButton = (label, handler) =>
    handler ? (
        <Button type="button" size="small" onClick={handler}>
            {label}
        </Button>
    ) : null

export const SectionFeedback = ({
    state,
    sectionName,
    onRetryLoad,
    onRetryRefresh,
    onAcceptStale,
}) => {
    const name = sectionName || 'section'
    let statusMessage = ''
    if (state.phase === SECTION_STATES.LOADING) statusMessage = `Loading ${name}.`
    if (state.phase === SECTION_STATES.MUTATING) statusMessage = `Saving ${name}.`
    if (state.phase === SECTION_STATES.REFRESHING) statusMessage = `Refreshing ${name}.`

    return (
        <React.Fragment>
            <div role="status" aria-live="polite" aria-atomic="true">
                {state.phase === SECTION_STATES.LOADING && <CircularProgress size={18} aria-hidden="true" />}
                {statusMessage}
            </div>
            {state.phase === SECTION_STATES.LOAD_ERROR && (
                <div role="alert">
                    <span>{`Error loading ${name}: ${state.loadError.message}`}</span>
                    {retryButton(`Retry ${name}`, onRetryLoad)}
                </div>
            )}
            {state.phase === SECTION_STATES.STALE && (
                <div role="alert">
                    <span>{state.mutationError.message}</span>
                    {retryButton('Review current values', onAcceptStale)}
                </div>
            )}
            {state.phase === SECTION_STATES.REFRESH_ERROR && (
                <div role="alert">
                    <span>{`Refresh failed for ${name}: ${state.refreshError.message}`}</span>
                    {retryButton(`Retry ${name} refresh`, onRetryRefresh)}
                </div>
            )}
            {!!state.mutationError && state.phase !== SECTION_STATES.STALE && (
                <div role="alert">{state.mutationError.message}</div>
            )}
        </React.Fragment>
    )
}

export const SectionStateBoundary = ({
    state,
    sectionName,
    emptyMessage,
    onRetryLoad,
    onRetryRefresh,
    onAcceptStale,
    children,
}) => {
    const hasData = hasConfirmedSectionData(state)
    const records = hasData ? state.confirmedData.records : []
    return (
        <React.Fragment>
            <SectionFeedback
                state={state}
                sectionName={sectionName}
                onRetryLoad={onRetryLoad}
                onRetryRefresh={onRetryRefresh}
                onAcceptStale={onAcceptStale}
            />
            {hasData && records.length === 0 && (
                <p>{emptyMessage || `No ${sectionName || 'records'} are configured.`}</p>
            )}
            {hasData && records.length > 0 &&
                (typeof children === 'function' ? children(state.confirmedData) : children)}
        </React.Fragment>
    )
}
